<template>
  <div v-if="!isConfirmed">
    <div class="form-group">
      <label class="form-label">Date</label>
      <ValidationProvider rules="required" ref="date" v-slot="{ errors }">
        <DateInput v-model="date" />
        <div class="text-danger" v-for="(error, i) of errors" :key="i">{{ error }}</div>
      </ValidationProvider>
    </div>

    <div class="form-group">
      <label class="form-label">Campus</label>
      <ValidationProvider rules="required" ref="campus" v-slot="{ errors }">
        <SelectCampusInput class="form-control col-sm-4" v-model="campus" />
        <div class="text-danger" v-for="(error, i) of errors" :key="i">{{ error }}</div>
      </ValidationProvider>
    </div>

    <div class="form-group">
      <label class="form-label">Comment</label>
      <ValidationProvider rules="required" ref="comment" v-slot="{ errors }">
        <Textarea class="form-control" v-model="comment" />
        <div class="text-danger" v-for="(error, i) of errors" :key="i">{{ error }}</div>
      </ValidationProvider>
    </div>
  </div>

  <div v-else>
    <div class="form-group">
      <label>Date</label>
      <div class="form-confirm-value">{{ date | ymd }}</div>
    </div>
    <div class="form-group">
      <label>Campus</label>
      <div class="form-confirm-value">{{ campus.name }}</div>
    </div>
    <div class="form-group">
      <label>Comment</label>
      <div class="form-confirm-value">{{ comment }}</div>
    </div>
    <div class="form-group" v-if="isExecuted()">
      <label>{{ status | status }} Comment</label>
      <div class="form-confirm-value">{{ approvedComment }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import _ from 'lodash'
import moment from 'moment'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { ValidationProvider } from 'vee-validate'
import { IAddApplicationComponent } from '@/components/pages/application/Add.vue'
import { Tutor } from '@/store/tutors/types'
import { WorkOvertimeApplication } from '@/store/applications/workOvertime/types'
import { Campus } from '@/store/master/types'
import SelectCampusInput from '@/components/parts/inputItem/SelectCampusInput.vue'
import DateInput from '@/components/parts/inputItem/DateInput.vue'
import Textarea from '@/components/parts/inputItem/Textarea.vue'
import { applicationStatusCode, ApplicationStatus } from '@/store/applications/types'

@Component({
  components: {
    ValidationProvider,
    SelectCampusInput,
    DateInput,
    Textarea,
  },
  filters: {
    ymd(date: Date) {
      return moment(date).format('YYYY/MM/DD')
    },
    status: (s: applicationStatusCode): string => ApplicationStatus[s],
  },
})
export default class ApplicationAddWorkOvertime extends Vue implements IAddApplicationComponent {
  @Prop({ required: true }) isConfirmed!: boolean

  // 編集時・詳細時など、初期値が必要な場合
  @Prop() initialValues!: WorkOvertimeApplication

  @Prop() status!: applicationStatusCode

  private date: Date|null = null

  private campus: Campus|null = null

  private comment: string|null = null

  private approvedComment: string|null = null

  private isValidated: boolean = false

  private created() {
    if (this.initialValues) {
      this.date = this.initialValues.date.toDate()
      this.campus = this.initialValues.campus
      this.comment = this.initialValues.comment
      this.approvedComment = this.initialValues?.approvedComment || null
    }

    this.$store.dispatch('fetchMasterVacationReasons')
  }

  /**
   * バリデーション（ApplicationAdd.vueから呼び出し）
   * @return {Promise} バリデーション結果
   */
  public validation(): Promise<boolean> {
    return Promise.all([
      'date', 'campus', 'comment',
    ].map((key) => (this.$refs[key] as any).validate()))
      .then((validationResults) => {
        const errorLength = _.filter(validationResults, { valid: false }).length

        if (errorLength === 0) {
          this.isValidated = true
          return true
        }
        return false
      })
  }

  /**
   * 登録（ApplicationAdd.vueから呼び出し）
   * @return {Promise} ActionからのPromise
   */
  public register(tutor: Tutor): Promise<void> {
    const application: WorkOvertimeApplication = {
      type: 'workOvertime',
      targetTutor: tutor,
      date: moment(this.date),
      campus: this.campus as Campus,
      comment: this.comment,
    }

    return this.$store.dispatch('registerWorkOvertimeApplication', application)
  }

  /**
   * 申請のステータスが未承認以外かチェック
   */
  private isExecuted() {
    return this.status !== 'unapproved'
  }
}
</script>

<style scoped>
</style>
